//PVQ Dropdown values
export const residencyStatusOptions = [
  'Permanent Resident',
  'Asylee/Refugee',
  'Nonimmigrant',
  'Temporary Protected Status (TPS)',
  'Deferred Action for Childhood Arrivals (DACA)',
  'Other',
];
